export const isTreeNodeDisabled = (node, categoryTypes) => {
  const isCategory = categoryTypes.includes(node.type)
  const children = node.children || []
  const hasDisabledChildren = children.every((child) => isTreeNodeDisabled(child, categoryTypes))
  return isCategory && (children.length === 0 || hasDisabledChildren)
}

export function prepareTreeData(nodes, categoryTypes, isDisabled, isLeaf) {
  return nodes.map((node) => {
    const disabled = isDisabled(node) || isTreeNodeDisabled(node, categoryTypes)
    return {
      ...node,
      key: node.opfId,
      value: node.opfId,
      disabled,
      disableCheckbox: disabled,
      children: node.children
        ? prepareTreeData(node.children, categoryTypes, isDisabled, isLeaf)
        : undefined,
      isLeaf: isLeaf(node),
    }
  })
}
